import { useState } from "react";
import { format } from "date-fns";
import { tr } from "date-fns/locale";
import { Calendar as CalendarIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";

function parseISO(v) {
  if (!v) return undefined;
  const m = String(v).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return undefined;
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
}
function toISO(d) {
  if (!d) return "";
  const y = d.getFullYear();
  const mo = String(d.getMonth() + 1).padStart(2, "0");
  const da = String(d.getDate()).padStart(2, "0");
  return `${y}-${mo}-${da}`;
}

export function DatePicker({ value, onChange, placeholder = "Tarih seçin", className, disabled, defaultOpen = false, onClosed, ...props }) {
  const [open, setOpenRaw] = useState(defaultOpen);
  const setOpen = (o) => { setOpenRaw(o); if (!o) onClosed?.(); };
  const selected = parseISO(value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          disabled={disabled}
          data-testid={props["data-testid"]}
          className={cn("w-full justify-start text-left font-normal", !selected && "text-muted-foreground", className)}
        >
          <CalendarIcon className="mr-2 h-4 w-4 shrink-0" />
          {selected ? format(selected, "dd.MM.yyyy", { locale: tr }) : <span>{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          locale={tr}
          showOutsideDays={false}
          selected={selected}
          defaultMonth={selected}
          onSelect={(d) => { if (d) { onChange(toISO(d)); setOpen(false); } }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
